import ElectronicApproveModal from './ElectronicApproveModal';

export default ElectronicApproveModal;
